<template>
  <div>
    <div v-if='tags.listLoading' class="loader-wrapper">
      <Loading/>
    </div>
    <PanelHelper v-else-if='panelHintVisible' v-bind='emptyPanelProps' />
    <div v-else class='h-100'>
      <div class='i-top-button-bar'>
        <div class="tag-search-wrap">
          <SearchText
              v-model="searchTerm"
              autocomplete="off"
              :placeholder="LANG.searchFor"
              :aria-label="LANG.searchFor"
              class="fts-as-you-type"
            />
        </div>
        <div class='button_container'>
          <i-button
            :disabled="checkACL['/data/ts/tag/create']"
            @click.prevent.stop="showModal = true"
            :title="LANG.createTag"
          >
            <i-icon :icon="'plus'" size="small"></i-icon>
            <span class="i-btn-label">{{ LANG.createTag }}</span>
          </i-button>
        </div>
      </div>

      <div class="flow-auto">
        <table class="filelist table" v-if="filteredList.length">
          <tbody>
            <tr v-for="tag in filteredList" :key="tag.name">
              <td class="name_cell">
                <a :title="tag.name">{{tag.name}}</a>
                <span v-if="tag.recommended" class="muted">{{LANG.recommended}}</span>
              </td>
              <td class="icon_cell">
                <TagMenuOptions :tag="tag" />
              </td>
            </tr>
          </tbody>
        </table>
        <PanelHelper v-else
          img="empty"
          :msg="LANG.noTagsHint"
        />
        <div class="footer"></div>
      </div>
    </div>

    <TagModalAddTag v-model:show="showModal"/>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';

import Button from '@/components/lib/button/Button.vue';
import Icon from '@/components/lib/icon/Icon.vue';

import Loading from '@/components/common/Loading.vue';
import PanelHelper from '@/components/common/PanelHelper.vue';
import SearchText from '@/components/common/SearchText.vue';
import TagMenuOptions from '@/components/tags/TagMenuOptions.vue';

import TagModalAddTag from './TagModalAddTag.vue';

export default defineComponent({
  components: {
    SearchText,
    PanelHelper,
    Loading,
    TagMenuOptions,
    TagModalAddTag,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  data() {
    return {
      searchTerm: '',
      showModal: false,
    };
  },
  computed: {
    ...mapState(['LANG', 'tags']),
    ...mapGetters(['checkACL']),
    ...mapGetters('tags', ['tagList']),
    filteredList() {
      const realmTags = this.tagList;
      if (!Array.isArray(realmTags)) return [];

      const term = this.searchTerm.toLowerCase();
      // FIXME: review tag.name... & tag.name.toLowerCase() is not a function
      return realmTags
        .filter((tag) => tag.name.toLowerCase && tag.name.toLowerCase().includes(term));
    },
    panelHintVisible() {
      const focused = !!this.tags.focusedRealm;
      const hasItems = !!(this.tags.realms);

      if (hasItems && focused) return false;

      return !hasItems || !focused;
    },
    emptyPanelProps() {
      const { LANG } = this;

      if (!this.tags.realms) {
        return {
          img: 'empty',
          msg: LANG.noTagRealmsHint,
        };
      }

      return {
        img: 'noFocus',
        msg: LANG.clickOnRealmHint,
      };
    },
  },
});
</script>

<style scoped lang='scss'>
.i-btn-label {
  margin-left: 5px;
}
.h-100 {
  height: 100%;
}

.flow-auto {
  height: calc(100% - 102px);
  overflow: auto;
}

.muted {
  font-size: 0.7em;
  margin-left: 1em;
  text-transform: lowercase;
}

.tag-search-wrap {
  width: 220px;
  display: inline-block;
  margin-bottom: 10px;
}

.icon_cell div {
  display: inline-block;
}
.loader-wrapper {
  margin: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
